import { CONFIGURATION_FEATURE_SETTINGS_MODES } from "shared/types/enums";

export const MODE_OPTIONS = [
    CONFIGURATION_FEATURE_SETTINGS_MODES.Enabled,
    CONFIGURATION_FEATURE_SETTINGS_MODES.ReportingOnly,
    CONFIGURATION_FEATURE_SETTINGS_MODES.Disabled
];
